import { toast } from "react-toastify";
import { Container } from "unstated";
import uuid from "uuid";
import defaultFilterTemplate from "../components/filter/defaultFilterTemplate.json";
import operatorList from "../helpers/operatorList";
import { Template } from "../types/Template.js";

interface IState {
  filters: IFilter[];
  imageLocation: string;
  props: {};
}

type Type = "string" | "number";

const initialState: IState = {
  filters: [],
  imageLocation: "",
  props: {}
};

interface IFilter {
  id: string;
  allowedValues?: any[] | object;
  parameter: string;
  operator: string;
  values: string[];
  isPrimary: boolean;
}

class FilterState extends Container<IState> {
  public state = initialState;

  public setFilters = (filters: IFilter[]) => {
    this.setState({ filters });
  };

  public addFilter = (
    operator: string,
    parameter: string,
    values: any[],
    isPrimary: boolean = false
  ) => {
    const { filters } = this.state;
    const id = uuid.v4();
    const newFilters = filters.concat({
      id,
      isPrimary,
      operator,
      parameter,
      values
    });

    this.setState({
      filters: newFilters
    });
  };

  public removeFilter = (id: string) => {
    const { filters } = this.state;

    const newFilters = filters.filter(f => f.id !== id);

    this.setState({
      filters: newFilters
    });
  };

  public clearFilters = () => {
    const { filters } = this.state;
    const newFilters = filters.filter((f: any) => f.isPrimary);
    const clearedFilters = newFilters.map((f: any) => {
      if (f.parameter === "templateId") {
        return f;
      }
      return {
        ...f,
        values: [""]
      };
    });

    toast.success("Filters Cleared");
    this.setState({ filters: clearedFilters });
  };

  public handleFilterParameter = (
    filterId: string,
    parameter: string,
    type: Type
  ) => {
    const { filters } = this.state;
    const filterIndex = filters.map(f => f.id).indexOf(filterId);
    if (filterIndex < 0) {
      return;
    }

    const newFilters = Object.assign([], filters, {
      [filterIndex]: {
        ...filters[filterIndex],
        operator: operatorList[type][0],
        parameter
      }
    });

    this.setState({ filters: newFilters });
  };

  public handleFilterOperator = (filterId: string, operator: string) => {
    const { filters } = this.state;

    const filterIndex = filters.map(f => f.id).indexOf(filterId);
    if (filterIndex < 0) {
      return;
    }
    const newFilters = Object.assign([], filters, {
      [filterIndex]: { ...filters[filterIndex], operator }
    });

    this.setState({ filters: newFilters });
  };

  public handleFilterValue = (filterId: string, value: string[]) => {
    const { filters } = this.state;
    const filterIndex = filters.map(f => f.id).indexOf(filterId);

    if (filterIndex < 0) {
      return;
    }

    const newFilters = Object.assign([], filters, {
      [filterIndex]: {
        ...filters[filterIndex],
        values: value
      }
    });

    this.setState({ filters: newFilters });
  };

  public handleTemplateSelect = ({
    parameters,
    templateId,
    imageLocation
  }: Template) => {
    this.setState({
      filters: [],
      imageLocation
    });
    const parametersWithDefaults = ["description", ...parameters]
    const primaryFilters = defaultFilterTemplate.parameters.filter(p => parametersWithDefaults.includes(p.name));
    const templateIdFilter = [
      {
        filterGroup: "template",
        id: uuid.v4(),
        isPrimary: true,
        operator: "contains",
        parameter: "templateId",
        type: "template",
        values: [templateId]
      },
    ];

    const newFilters = templateIdFilter.concat(
      primaryFilters.map(f => {
        return {
          allowedValues: f.allowedValues,
          column: f.column,
          filterGroup: f.filterGroup,
          id: uuid.v4(),
          isPrimary: true,
          operator: f.operator,
          order: f.order || 999,
          parameter: f.name,
          type: f.type,
          values: [""]
        };
      })
    );

    this.setState({ filters: newFilters });
  };
}

export default FilterState;
